var _rect, _path, _path2, _rect2, _rect3, _rect4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoachesBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 784,
    viewBox: "0 0 1920 784",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 784,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3072 -6083C-3072 -6084.1 -3071.1 -6085 -3070 -6085H19380C19381.1 -6085 19382 -6084.1 19382 -6083V18783C19382 18784.1 19381.1 18785 19380 18785H-3070C-3071.11 18785 -3072 18784.1 -3072 18783V-6083Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-3070 -6084H19380V-6086H-3070V-6084ZM19381 -6083V18783H19383V-6083H19381ZM19380 18784H-3070V18786H19380V18784ZM-3071 18783V-6083H-3073V18783H-3071ZM-3070 18784C-3070.55 18784 -3071 18783.6 -3071 18783H-3073C-3073 18784.7 -3071.66 18786 -3070 18786V18784ZM19381 18783C19381 18783.6 19380.6 18784 19380 18784V18786C19381.7 18786 19383 18784.7 19383 18783H19381ZM19380 -6084C19380.6 -6084 19381 -6083.55 19381 -6083H19383C19383 -6084.66 19381.7 -6086 19380 -6086V-6084ZM-3070 -6086C-3071.66 -6086 -3073 -6084.66 -3073 -6083H-3071C-3071 -6083.55 -3070.55 -6084 -3070 -6084V-6086Z",
    fill: "black",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 3437,
    transform: "translate(0 -160)",
    fill: "#D2D5D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 3437,
    transform: "translate(0 -160)",
    fill: "#F6F5FB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 784,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1415,
    cy: 837,
    r: 245,
    fill: "#ECEAF6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 187,
    r: 151,
    fill: "#E1B0C1",
    fillOpacity: 0.24
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1919,
    height: 784,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachesBg);
export default __webpack_public_path__ + "static/media/coaches_bg.0f53a6a5bbff80a6e8ecca9e8694087a.svg";
export { ForwardRef as ReactComponent };